import {createContext, FC, useContext, useState} from 'react';
import {useTransport} from '../../transport/transport-provider';
import {EndpointsEnum} from '../../constants/endpoints';
import {CommonEntityProvider, ICommonComponentProps} from '../../definitions/common.definitions';
import {isFunction} from '../../utils/funtion';

export type CalcEntityT = {
  operation: number;
  area?: number;
  consumerType?: number;
  length?: number;
  maximumPower?: number;
  reliabilityCategory?: number;
  voltageLevel?: number;
}

export type CalcContextT = CommonEntityProvider<CalcEntityT[]> & {
  doCalc: (entity: CalcEntityT, cb?: () => void) => Promise<number>;
}

const context = createContext<CalcContextT>(null!);
const CalcContextProvider = context.Provider;
const useCalc = () => useContext(context);

const CalcProvider: FC<ICommonComponentProps> = (props) => {
  const {
    children,
  } = props;
  const [time, setTime] = useState(Date.now());
  const [loading, setLoading] = useState(false);

  const {
    send,
  } = useTransport();

  const doCalc = async (entity: CalcEntityT, cb?: () => void) => {
    setLoading(true);
    const result = await send<CalcEntityT, number>({
      method: 'POST',
      path: EndpointsEnum.CALC,
      data: entity,
    });
    setLoading(false);
    setTime(Date.now());
    if (isFunction(cb)) {
      cb();
    }
    return result;
  }

  const ctx: CalcContextT = {
    doCalc,
    isLoading: loading,
  }

  return (
    <CalcContextProvider
      value={ctx}
    >
      {children}
    </CalcContextProvider>
  )
}

export default CalcProvider;
export {
  CalcProvider,
  useCalc,
}